<template>
  <div class="flex bg-white border-r border-gray-800 rounded-l leading-none items-center align-center"
        :class="{'w-full': stretch}">
    <SortTextEntry  class="px-1 rounded-l lg:rounded-l bg-white cursor-default h-full"
                    :class="{ 'bg-gray-200' : !editable }"
                    v-model="linked_description"
                    :disabled="disabled"
                    :active="active"
                    @text-entry-clicked="textEntryClicked"></SortTextEntry>
    <div class="flex flex-col justify-center w-4 cursor-pointer bg-gray-200 hover:text-gray-500 h-full align-center"
          @click="$emit('toggle-description')">
      <svg v-if="stretch" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
      </svg>
      <svg v-else xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
      </svg>
    </div>
  </div>
</template>

<script>
import SortTextEntry from '@/components/ui/SortTextEntry'

export default {
  name: 'RowLinkedDescription',
  components: {
    SortTextEntry
  },
  props: {
    value: String,
    editable: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    stretch: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: true
    },
  },
  computed: {
    linked_description: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      }
    },
  },
  methods: {
    textEntryClicked(){
      if(!this.disabled){
        this.$emit('edit-reference')
      }
    }
  }
};
</script>
